import { Component } from 'react';
import Database from './Contents/Database'
import Modules from './Contents/Modules'
import Methods from './Contents/Methods'
//import DefaultContent from './Content'

export const Content = [
    { id: 'database', title: 'Databáze', content: <Database /> },
    { id: 'modules',  title: 'Moduly',   content: <Modules />  },
    { id: 'methods',  title: 'Metody',   content: <Methods />  }
 //,{ id: 'test',     title: 'Test',     fetchUrl: 'data/methods.json' }
]

export default class ContentSelector extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: []
        };
    }

    async componentDidMount() {

    }

    render() {
        const contentData = Content.find(content => content.id === this.props.id);
        const contentComponent = contentData.content;
        return contentComponent;
    }
}